import $ from 'jquery'

export const init = async function () {
  $('.js-pin').on('click', function () {
    // hide all tooltips
    $('.js-tooltip').removeClass('show')

    // hide all text
    $('.js-map-pin-text').removeClass('show')

    const no = $(this).attr('id')?.replace('js-pin-', '')
    $('#js-tooltip-' + no).addClass('show')
    $('#js-map-pin-text-' + no).addClass('show')
  })
}
